// extracted by mini-css-extract-plugin
export default {"arrowIcon":"MenuDetails_arrowIcon__PbRd5","backIcon":"MenuDetails_backIcon__xhVLN","forwardIcon":"MenuDetails_forwardIcon__QOZhI"};